import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import nls from '../../../../nls/pt-BR.json';
import {
  setCurrentProgressTo,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { LayoutsValuation } from '../../components/layoutsValuation';

export const LayoutsValuationPrimary: React.FC = () => {
  const { layoutsValuationPrimaryResponse } = useSelector(studiesSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentProgressTo(2));
  }, []);
  return (
    <div className="layouts-valuation">
      <h6 className="layouts-valuation__title">
        {nls.studyCreationGuide.steps.step2.unitsValuation}
      </h6>
      {layoutsValuationPrimaryResponse && (
        <LayoutsValuation
          valuationData={layoutsValuationPrimaryResponse}
          isPrimaryMarket
        />
      )}
    </div>
  );
};
